import { connect } from "react-redux";

import registrationStep from "../../registrationStep";
import QuestionnairePage from "./QuestionnairePage";
import { withFirebase } from "../../../data/index";

import { Creators } from "../../reducer";

const withData = withFirebase(QuestionnairePage, ["questions/adult"]);
const withState = connect(
  state => ({
    questionnaire: "adult",
    questions: state.data.questions.adult
  }),
  (dispatch, { history, match }) => ({
    onAnswer: (questionnaire, index, answer) => {
      dispatch(Creators.saveQuestionnaireAnswer(questionnaire, index, answer));
    }
  })
)(withData);

export default registrationStep(withState, "questionnaire", "range-rental");



// WEBPACK FOOTER //
// ./src/registration/components/Questionnaire/index.js